module.exports = __webpack_public_path__ + "img/huxi_des_1.d13a6d05.jpg";